import React from 'react';
import clsx from 'clsx';
import ProductPrice from '@components/molecules/products/product-details/components/product-price/product-price';
import ShippingRestriction from '@components/molecules/products/product-details/components/shipping-restriction/shipping-restriction';
import useProductQuery from '@hooks/product/use-product-query';
import useProductShippingQuery from '@hooks/product/use-product-shipping-query';
import usePdpLayout from '@hooks/product/use-pdp-layout';
import WelcomeVoucherWrapper from '@components/catalog/welcome-voucher/welcome-voucher-wrapper';
import SellerOnVacationWrapper from '@components/molecules/products/product-details/components/seller-on-vacation/seller-on-vacation-wrapper';
import HeroPDPHeader from '../hero-pdp-header/hero-pdp-header';
import HeroPDPProductDetails from '../hero-pdp-product-details/hero-pdp-product-details';
import styles from '../hero-pdp-details/hero-pdp-details.module.scss';
import HeroPdpCta from '../hero-pdp-cta/hero-pdp-cta';

const HeroPDPDetails: React.FC = (): JSX.Element => {
  const { product, userTransactionRole } = useProductQuery();
  const { productShipping } = useProductShippingQuery();
  const { isRecirculation } = usePdpLayout();

  const isSeller: boolean = userTransactionRole === 'seller';
  const shouldShowShippingRestriction = productShipping?.prohibited && !isSeller;

  return (
    <div className={clsx(styles.heroPdpDetails, isRecirculation && styles['heroPdpDetails--recirculation'])}>
      <HeroPDPHeader productDetails={product} />
      <HeroPDPProductDetails
        product={product}
        customClass={styles.heroPdpDetails__productDetails}
      />
      <div className={styles.heroPdpDetails__offerSection}>
        <ProductPrice
          product={product}
          directShippingEligible={true}
          customPriceClass={clsx(styles.heroPdpDetails__offerSection__productPrice)}
        />
      </div>

      {!isRecirculation && <WelcomeVoucherWrapper customClass={styles.heroPdpDetails__welcomeVoucher} />}
      {shouldShowShippingRestriction && <ShippingRestriction className={styles.heroPdpDetails__shippingRestriction} />}
      <SellerOnVacationWrapper className={styles.heroPdpDetails__sellerOnVacation} />
      <HeroPdpCta />
    </div>
  );
};

export default HeroPDPDetails;
